import { Component, Input } from '@angular/core';
import { Country } from 'src/app/core/countries.service';

@Component({
  selector: 'app-shared-country-prefix',
  templateUrl: './shared-country-prefix.component.html',
  styleUrls: ['./shared-country-prefix.component.scss'],
})
export class SharedCountryPrefixComponent {
  @Input() country_prefix?: Country;
}
